import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUserArticle } from '../store/user/userSlice';
import Main from '../pages/Main/Main'
import AddSection from '../pages/Main/AddSection'
import VideoMessage from '../pages/Main/AddSection/VideoMessage/VideoMessage'
import AddMusic from '../pages/Main/AddSection/Music/AddMusic'
import SearchForRelease from '../pages/Main/AddSection/Music/SearchForRelease/SearchForRelease'
import MusicPlatformPage from '../pages/Main/AddSection/Music/MusicPlatformPage'
import ManualEntry from '../pages/Main/AddSection/Music/Manual/ManualEntry'
import AddLink from '../pages/Main/AddSection/Music/Manual/AddLink'
import AddEvent from '../pages/Main/AddSection/Event/AddEvent'
import BlukImportEvent from '../pages/Main/AddSection/Event/BulkImport/BlukImportEvent'
import ImportSingleEvent from '../pages/Main/AddSection/Event/SingleImport/ImportSingleEvent'
import ImportLink from '../pages/Main/AddSection/Event/SingleImport/ImportLink'
import CustomEvent from '../pages/Main/AddSection/Event/CustomEvent/CustomEvent'
import DatePickerPage from '../pages/Main/AddSection/Event/DatePickerPage'
import AddProduct from '../pages/Main/AddSection/Product/AddProduct'
import ImportProduct from '../pages/Main/AddSection/Product/ImportProduct/ImportProduct'
import ImportLinkProduct from '../pages/Main/AddSection/Product/ImportProduct/ImportLinkProduct'
import ManuallyAddProduct from '../pages/Main/AddSection/Product/CustomProduct/ManuallyAddProduct'
import AddForm from '../pages/Main/AddSection/Form/AddForm'
import AddFormLink from '../pages/Main/AddSection/Form/Form/AddFormLink'
import AddPoll from '../pages/Main/AddSection/Form/Form/AddPoll'
import AddLinkSocialFeed from '../pages/Main/AddSection/SocialFeed/Social/AddLinkSocialFeed'
import SelectVideoPlatform from '../pages/Main/AddSection/Video/SelectVideoPlatform'
import AddLinkVideo from '../pages/Main/AddSection/Video/AddLinkVideo'
import PlaylistPlatform from '../pages/Main/AddSection/Playlist/PlaylistPlatform'
import PlaylistLink from '../pages/Main/AddSection/Playlist/PlaylistLink'
import AddSocialFed from '../pages/Main/AddSection/SocialFeed/AddSocialFed'
// import AddCustomlink from '../pages/Main/AddSection/Customlink/AddCustomlink'
// import ExistingSection from '../pages/Main/AddSection/Customlink/ExistingSection'
// import CreateNewSection from '../pages/Main/AddSection/Customlink/CreateNewSection'
import { SocialEdit } from '../components/Main/ArticleEdit/SocialEdit'
import Selectpage from '../pages/Focuspage/Selectpage'
import SelectType from '../pages/Focuspage/Type/SelectType'
import SelectMusicType from '../pages/Focuspage/Type/Music/SelectMusicType'
import Step1 from '../pages/Focuspage/Type/Music/Form/Step1'
import Step2 from '../pages/Focuspage/Type/Music/Form/Step2'
import Step3 from '../pages/Focuspage/Type/Music/Form/Step3'
import Step4 from '../pages/Focuspage/Type/Music/Form/Step4'
import Step5 from '../pages/Focuspage/Type/Music/Form/Step5'
import Step6 from '../pages/Focuspage/Type/Music/Form/Step6'
import Step7 from '../pages/Focuspage/Type/Music/Form/Step7'
import Step8 from '../pages/Focuspage/Type/Music/Form/Step8'
import Step9 from '../pages/Focuspage/Type/Music/Form/Step9'
import MultiStep6 from '../pages/Focuspage/Type/Music/Form/MultiStep6'
import MusicPage from '../pages/Focuspage/Type/Music/MusicPage'
import SelectProductType from '../pages/Focuspage/Type/Product/SelectProductType'
import ProductStep1 from '../pages/Focuspage/Type/Product/Form/Step1'
import ProductStep2 from '../pages/Focuspage/Type/Product/Form/Step2'
import ProductStep3 from '../pages/Focuspage/Type/Product/Form/Step3'
import ProductStep4 from '../pages/Focuspage/Type/Product/Form/Step4'
import ProductStep5 from '../pages/Focuspage/Type/Product/Form/Step5'
import ProductStep6 from '../pages/Focuspage/Type/Product/Form/Step6'
import ProductStep7 from '../pages/Focuspage/Type/Product/Form/Step7'
import SelectEventType from '../pages/Focuspage/Type/Event/SelectEventType'
import EventStep1 from '../pages/Focuspage/Type/Event/Form/Step1'
import EventStep2 from '../pages/Focuspage/Type/Event/Form/Step2'
import EventStep3 from '../pages/Focuspage/Type/Event/Form/Step3'
import EventStep4 from '../pages/Focuspage/Type/Event/Form/Step4'
import EventStep5 from '../pages/Focuspage/Type/Event/Form/Step5'
import EventStep6 from '../pages/Focuspage/Type/Event/Form/Step6'
import EventStep7 from '../pages/Focuspage/Type/Event/Form/Step7'
import DatePickerFocus from '../pages/Focuspage/Type/Event/DatePicker'

import NewsletterStep1 from '../pages/Focuspage/Type/Newsletter/Form/Step1'
import NewsletterStep2 from '../pages/Focuspage/Type/Newsletter/Form/Step2'
import NewsletterStep3 from '../pages/Focuspage/Type/Newsletter/Form/Step3'
import NewsletterStep4 from '../pages/Focuspage/Type/Newsletter/Form/Step4'
import NewsletterStep5 from '../pages/Focuspage/Type/Newsletter/Form/Step5'
import NewsletterStep6 from '../pages/Focuspage/Type/Newsletter/Form/Step6'
import NewsletterStep7 from '../pages/Focuspage/Type/Newsletter/Form/Step7'
import SelectNewsletterType from '../pages/Focuspage/Type/Newsletter/SelectNewsletterType'
import ProductPage from '../pages/Focuspage/Type/Product/ProductPage'
import EventPage from '../pages/Focuspage/Type/Event/EventPage'
import NewsletterPage from '../pages/Focuspage/Type/Newsletter/NewsletterPage'
import MultipleMusicPage from '../pages/Focuspage/Type/Music/MultipleMusicPage'
import MultipleProductPage from '../pages/Focuspage/Type/Product/MultipleProductPage'
import MultipleNewsletterPage from '../pages/Focuspage/Type/Newsletter/MultipleNewsletterPage'
import MultipleEventPage from '../pages/Focuspage/Type/Event/MultipleEventPage'
import SelectOption from '../pages/More/SelectOption'
import SettingOption from '../pages/More/Setting/SettingOption'
import Profile from '../pages/More/Setting/Profile/Profile'
import ProfilePhoneEdit from '../pages/More/Setting/Profile/ProfilePhoneEdit'
import OldPhone from '../pages/More/Setting/Advanced/Phone/OldPhone'
import VerifyOldPhone from '../pages/More/Setting/Advanced/Phone/VerifyOldPhone'
import NewPhone from '../pages/More/Setting/Advanced/Phone/NewPhone'
import VerifyNewPhone from '../pages/More/Setting/Advanced/Phone/VerifyNewPhone'
import DelegateAccess from '../pages/More/Setting/Advanced/DelegateAccess/DelegateAccess'
import TeamManagement from '../pages/More/Setting/Advanced/DelegateAccess/TeamManagement'
// import TeamMemberEdit from '../pages/More/Setting/Advanced/DelegateAccess/TeamMemberEdit' // Now using Apps version
import Subscription from '../pages/More/Setting/Subscription/Subscription'
import PaymentSuccess from '../pages/More/Setting/Subscription/PaymentSuccess'
import PaymentFailed from '../pages/More/Setting/Subscription/PaymentFailed'
import Analytics from '../pages/More/Analytics/Analytics'
import VideoMessageAnalytics from '../pages/More/Analytics/VideoMessage/VideoMessage'
import MusicAnalytics from '../pages/More/Analytics/Music/MusicAnalytics'
import VideoAnalytics from '../pages/More/Analytics/Video/VideoAnalytics'
import EventAnalytics from '../pages/More/Analytics/Event/EventAnalytics'
import ProductAnalytics from '../pages/More/Analytics/Product/ProductAnalytics'
import Domain from '../pages/Domain/Domain'
import Filter from '../pages/More/Analytics/VideoMessage/Filter'
import SocialFeedAnalytics from '../pages/More/Analytics/SocialFeed/SocialfeedAnalytics'
import PlaylistAnalytics from '../pages/More/Analytics/Playlist/PlaylistAnalytics'
import MusicPlatformData from '../pages/More/Analytics/Music/MusicPlatformData'
import FormAnalytics from '../pages/More/Analytics/Form/FormAnalytics'
import FormsAnalytics from '../pages/More/Analytics/Form/Forms/FormsAnaltytics'
import PollsAnalytics from '../pages/More/Analytics/Form/Polls/PollsAnalytics'
import MusicDataPage from '../pages/Main/Pages/Music/MusicDataPage'
import PlaylistDataPage from '../pages/Main/Pages/Playlist/PlaylistDataPage'
import Follower from '../pages/Domain/Follower'
import Following from '../pages/Domain/Following'
import ImportBulkProduct from '../pages/Main/AddSection/Product/ImportProduct/ImportBulkProduct'
import ConnectWithShopify from '../pages/Main/AddSection/Product/ImportProduct/ConnectWithShopify'
import { useSelector } from 'react-redux'
import Suggested from '../pages/Personal/Suggested'
import Explore from '../pages/Personal/Explore'
import Top from '../pages/Personal/Top'
import Trending from '../pages/Personal/Trending'
import FollowingPersonal from '../pages/Personal/Following'
import Search from '../pages/Personal/Search'
import PlayBackOption from '../pages/Main/AddSection/Music/PlaybackOption'
import PublishOption from '../pages/Main/AddSection/Publish/Option'
import Advanced from '../pages/More/Setting/Advanced/Advanced'
import Notifications from '../pages/More/Setting/Advanced/Notifications'
import Redirect from '../pages/More/Setting/Advanced/Redirect/Redirect'
import VerifyOldEmail from '../pages/More/Setting/Advanced/Email/VerifyOldEmail'
import NewEmail from '../pages/More/Setting/Advanced/Email/NewEmail'
import VerifyNewEmail from '../pages/More/Setting/Advanced/Email/VerifyNewEmail'
import CloseAccount from '../pages/More/Setting/Advanced/CloseAccount'
import Gmail from '../pages/More/Setting/Gmail/Gmail'
import EmailTracking from '../pages/More/Setting/Gmail/EmailTracking'
import EmailSearch from '../pages/More/Setting/Gmail/EmailSearch'
import EmailApp from '../pages/Email/EmailApp'
import EmailAppTracking from '../pages/Email/EmailTracking'
import EmailAppSearch from '../pages/Email/EmailSearch'
import CustomSection from '../pages/Main/AddSection/Custom/CustomSection'
import CreateNew from '../pages/Main/AddSection/Custom/CreateNew'
import ExistingSection from '../pages/Main/AddSection/Custom/ExistingSection'
import SelectStyle from '../pages/Main/AddSection/Custom/SelectStyle'
import CustomFocusPage from '../pages/Focuspage/Type/Custom/CustomFocusPage'
import CustomStep1 from '../pages/Focuspage/Type/Custom/Form/Step1'
import CustomStep2 from '../pages/Focuspage/Type/Custom/Form/Step2'
import CustomStep3 from '../pages/Focuspage/Type/Custom/Form/Step3'
import CustomStep4 from '../pages/Focuspage/Type/Custom/Form/Step4'
import CustomStep5 from '../pages/Focuspage/Type/Custom/Form/Step5'
import CustomStep6 from '../pages/Focuspage/Type/Custom/Form/Step6'
import AddMusicContent from '../pages/Focuspage/Type/Custom/Form/AddMusicContent'
import AddVideoContent from '../pages/Focuspage/Type/Custom/Form/AddVideoContent'
import AddEventContent from '../pages/Focuspage/Type/Custom/Form/AddEventContent'
import AddProductContent from '../pages/Focuspage/Type/Custom/Form/AddProductContent'
import AddSocialContent from '../pages/Focuspage/Type/Custom/Form/AddSocialContent'
import AddTextContent from '../pages/Focuspage/Type/Custom/Form/AddTextContent'
import AddFormContent from '../pages/Focuspage/Type/Custom/Form/AddFormContent'
import AddGalleryContent from '../pages/Focuspage/Type/Custom/Form/AddGalleryContent'
import EditGalleryContent from '../pages/Focuspage/Type/Custom/Form/EditGalleryContent'
import EditFormContent from '../pages/Focuspage/Type/Custom/Form/EditFormContent'
import Appshub from '../pages/Apps/Appshub'
import Createapp from '../pages/Apps/Createapp'
import MarketplaceHub from '../pages/Marketplace/MarketplaceHub'
import DesignOverview from '../pages/DesignOverview/DesignOverview'
import ImageHostApp from '../pages/Apps/ImageHost/ImageHostApp'
import EditTextContent from '../pages/Focuspage/Type/Custom/Form/EditTextContent'
import EditSocialContent from '../pages/Focuspage/Type/Custom/Form/EditSocialContent'
import EditProductContent from '../pages/Focuspage/Type/Custom/Form/EditProductContent'
import EditEventContent from '../pages/Focuspage/Type/Custom/Form/EditEventContent'
import EditVideoContent from '../pages/Focuspage/Type/Custom/Form/EditVideoContent'
import EditMusicContent from '../pages/Focuspage/Type/Custom/Form/EditMusicContent'
import EditSingleMusic from '../pages/Focuspage/Type/Music/Edit/EditSingleMusic'
import EditSingleMusicPlatforms from '../pages/Focuspage/Type/Music/Edit/EditSingleMusicPlatforms'
import EditMultipleMusic from '../pages/Focuspage/Type/Music/Edit/EditMultipleMusic'
import EditMultipleMusicPlatforms from '../pages/Focuspage/Type/Music/Edit/EditMultipleMusicPlatforms'
import Landing from '../pages/landing'
import PersonalLanding from '../pages/landing/personal'
import Homepage from '../pages/home/Homepage'
import Vault from '../pages/Main/Vault'
import AddVault from '../pages/Main/AddVault'
import StreamOverlay from '../pages/Main/StreamOverlay'
import ProductEditContent from '../pages/Focuspage/Type/Product/EditContent'
import EditMultiProductContent from '../pages/Focuspage/Type/Product/EditMultiContent'
import EventEditContent from '../pages/Focuspage/Type/Event/EditContent'
import EditMultiEventContent from '../pages/Focuspage/Type/Event/EditMultiContent'
import NewsletterEditContent from '../pages/Focuspage/Type/Newsletter/EditContent'
import MultiNewsletterEditContent from '../pages/Focuspage/Type/Newsletter/EditMultiContent'
import AddMusicContent1 from '../pages/Main/AddSection/Custom/AddMusicContent'
import AddVideoContent1 from '../pages/Main/AddSection/Custom/AddVideoContent'
import AddEventContent1 from '../pages/Main/AddSection/Custom/AddEventContent'
import AddProductContent1 from '../pages/Main/AddSection/Custom/AddProductContent'
import AddSocialContent1 from '../pages/Main/AddSection/Custom/AddSocialContent'
import AddTextContent1 from '../pages/Main/AddSection/Custom/AddTextContent'
import AddFormContent1 from '../pages/Main/AddSection/Custom/AddFormContent'
import AddGalleryContent1 from '../pages/Main/AddSection/Custom/AddGalleryContent'
import EditMusicContent1 from '../pages/Main/AddSection/Custom/EditMusicContent'
import EditVideoContent1 from '../pages/Main/AddSection/Custom/EditVideoContent'
import EditEventContent1 from '../pages/Main/AddSection/Custom/EditEventContent'
import EditProductContent1 from '../pages/Main/AddSection/Custom/EditProductContent'
import EditSocialContent1 from '../pages/Main/AddSection/Custom/EditSocialContent'
import EditTextContent1 from '../pages/Main/AddSection/Custom/EditTextContent'
import EditFormContent1 from '../pages/Main/AddSection/Custom/EditFormContent'
import EditGalleryContent1 from '../pages/Main/AddSection/Custom/EditGalleryContent'
import ManagerApp from '../pages/Manager/ManagerApp'
import CustomPage from '../pages/Main/AddSection/Music/Custom/CustomPage'
import BookingsApp from '../pages/Bookings/BookingsApp'
import LoginAgency from '../pages/Bookings/LoginAgency'
import BulkImport from '../pages/Bookings/BulkImport'
import ManualAdd from '../pages/Bookings/ManualAdd'
import BookingsViewAll from '../pages/Bookings/ViewAll'
import EditBooking from '../pages/Bookings/EditBooking'
import CatalogApp from '../pages/Catalog/CatalogApp'
import BrowseCatalog from '../pages/Catalog/BrowseCatalog'
import CreateListing from '../pages/Catalog/CreateListing'
import MyListings from '../pages/Catalog/MyListings'
import LoginCatalog from '../pages/Catalog/LoginCatalog'
import ManualAddCatalog from '../pages/Catalog/ManualAddCatalog'
import BulkImportCatalog from '../pages/Catalog/BulkImportCatalog'
import CatalogViewAll from '../pages/Catalog/ViewAll'
import EditCatalog from '../pages/Catalog/EditCatalog'
import MerchApp from '../pages/Merch/MerchApp'
import MerchBulkImport from '../pages/Merch/BulkImport'
import MerchManualAdd from '../pages/Merch/ManualAdd'
import MerchViewAll from '../pages/Merch/ViewAll'
import EditMerch from '../pages/Merch/EditMerch'
import UnreleasedApp from '../pages/Unreleased/UnreleasedApp'
import IndividualImport from '../pages/Catalog/IndividualImport'
import PagesApp from '../pages/Pages/PagesApp'
import PromptsHub from '../pages/Prompts/PromptsHub'
import CreatePrompt from '../pages/Prompts/CreatePrompt'
import PromptLibrary from '../pages/Prompts/PromptLibrary'
import AnalyticsApp from '../pages/Analytics/AnalyticsApp'
import AnalyticsHub from '../pages/Analytics/AnalyticsHub'
import BookingsAnalytics from '../pages/Analytics/BookingsAnalytics'
import CatalogAnalytics from '../pages/Analytics/CatalogAnalytics'
import MerchAnalytics from '../pages/Analytics/MerchAnalytics'
import ExpertsAnalytics from '../pages/Analytics/ExpertsAnalytics'
import ChartingAnalytics from '../pages/Analytics/ChartingAnalytics'
import PlaylistingAnalytics from '../pages/Analytics/PlaylistingAnalytics'
import SocialListeningAnalytics from '../pages/Analytics/SocialListeningAnalytics'
import SpotifyRevenueAnalytics from '../pages/Analytics/SpotifyRevenueAnalytics'
import TourManagerAnalytics from '../pages/Analytics/TourManagerAnalytics'
import UsageDashboard from '../pages/Usage/UsageDashboard'
import ActivityFeedPage from '../pages/ActivityFeedPage'
import ChartingApp from '../pages/Charting/ChartingApp'
import PlaylistingApp from '../pages/Playlisting/PlaylistingApp'
import SocialListeningApp from '../pages/SocialListening/SocialListeningApp'
import SpotifyRevenueApp from '../pages/SpotifyRevenue/SpotifyRevenueApp'
import SpotifyCallback from '../components/SpotifyCallback'
import GmailCallback from '../components/GmailCallback'
import GoogleCalendarCallback from '../components/GoogleCalendarCallback'
import GoogleCallback from '../components/GoogleCallback'
import AllApps from '../pages/Apps/AllApps'
import ConnectorsApp from '../pages/Connectors/ConnectorsApp'
import GoogleCalendarConnector from '../pages/Connectors/GoogleCalendarConnector'
import GoogleConnector from '../pages/Connectors/GoogleConnector'
import BandsintownConnector from '../pages/Connectors/BandsintownConnector'
import TasksApp from '../pages/Tasks/TasksApp'
import TasksQuickReminder from '../pages/Tasks/QuickReminder'
import RemindersApp from '../pages/Reminders/RemindersApp'
import ManualAddReminder from '../pages/Reminders/ManualAddReminder'
import QuickReminder from '../pages/Reminders/QuickReminder'
import FlowsApp from '../pages/Flows/FlowsApp'
import FlowsCreate from '../pages/Flows/FlowsCreate'
import FlowsQuickReminder from '../pages/Flows/QuickReminder'
import WorkflowDetail from '../pages/Flows/WorkflowDetail'
import CreateCustomWorkflow from '../pages/Flows/CreateCustomWorkflow'
import FlowsViewAll from '../pages/Flows/FlowsViewAll'
import KnowledgeBaseApp from '../pages/KnowledgeBase/KnowledgeBaseApp'
import ContactsApp from '../pages/Apps/ContactsApp'
import AddContact from '../pages/Apps/AddContact'
import TeamManagementApp from '../pages/Apps/TeamManagementApp'
import TeamMemberEdit from '../pages/Apps/TeamMemberEdit'
import KnowledgeBaseArticle from '../pages/KnowledgeBase/KnowledgeBaseArticle'
import NotesApp from '../pages/Notes/NotesApp'
import NoteDetail from '../pages/Notes/NoteDetail'
import TourManagerApp from '../pages/TourManager/TourManagerApp'
import ViewAllTourManager from '../pages/TourManager/ViewAll'
import BulkImportTourManager from '../pages/TourManager/BulkImport'
import TourShowDetail from '../pages/TourManager/TourShowDetail'
import FlightSearch from '../pages/TourManager/FlightSearch'
import HotelSearch from '../pages/TourManager/HotelSearch'
import TourRouter from '../pages/TourManager/TourRouter'
import TourOverview from '../pages/TourManager/TourOverview'
import AddGroundTransport from '../pages/TourManager/AddGroundTransport'
import TeamMemberDashboard from '../pages/Manager/ManagerDashboard'
import TeamMemberSettings from '../pages/Manager/TeamMemberSettings'
import TeamMemberProfile from '../pages/Manager/TeamMemberProfile'
import TeamMemberSubscription from '../pages/Manager/TeamMemberSubscription'
import TeamMemberAdvanced from '../pages/Manager/TeamMemberAdvanced'
import TeamMemberVerifyOldEmail from '../pages/Manager/TeamMemberVerifyOldEmail'
import TeamMemberNewEmail from '../pages/Manager/TeamMemberNewEmail'
import TeamMemberVerifyNewEmail from '../pages/Manager/TeamMemberVerifyNewEmail'
import EditProtectedRoute from '../components/Permissions/EditProtectedRoute';
import FloatingTourChat from '../components/InteractiveTour/FloatingTourChat';
import {
    TOUR_SECTIONS,
    TOUR_CONTENT,
    QUICK_RESPONSES,
    QUESTION_ANSWERS,
    SECTION_QA,
    setCurrentTourSection,
    completeTour,
    getSectionWelcomeMessage,
    loadTourMessages,
    saveTourMessages,
    clearTourMessages,
    getCurrentTourSection
} from '../utils/interactiveTour';

// Smooth route wrapper for better transitions
const RouteWrapper = ({ children }) => (
  <div className="route-wrapper fade-in">
    {children}
  </div>
);

function PrivateRoutes() {
    const dispatch = useDispatch();
    const { userArticle } = useSelector((state) => state.user);
    let user = localStorage.getItem('dizeeUser');
    user = JSON.parse(user);
    const token = localStorage.getItem('dizeeToken');
    
    // Load user into Redux from localStorage on mount
    useEffect(() => {
        if (user && !userArticle) {
            dispatch(setUserArticle(user));
        }
    }, [user, userArticle, dispatch]);
    
    // Add state to track localStorage changes
    const [selectedArtist, setSelectedArtist] = useState(localStorage.getItem('selectedArtist'));
    
    // Tour state management
    const [tourMessages, setTourMessages] = useState([]);
    const [currentTourSectionState, setCurrentTourSectionState] = useState(null);
    const [isNavigatingTour, setIsNavigatingTour] = useState(false);
    const navigation = useNavigate();
    const location = useLocation();
    
    // Listen for localStorage changes
    useEffect(() => {
        const handleStorageChange = () => {
            setSelectedArtist(localStorage.getItem('selectedArtist'));
        };
        
        // Listen for localStorage changes
        window.addEventListener('storage', handleStorageChange);
        
        // Also check for changes when component updates (for same-tab changes)
        const interval = setInterval(() => {
            const current = localStorage.getItem('selectedArtist');
            if (current !== selectedArtist) {
                setSelectedArtist(current);
            }
        }, 100);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(interval);
        };
    }, [selectedArtist]);
    
    // Load saved tour messages on mount
    useEffect(() => {
        const savedMessages = loadTourMessages();
        if (savedMessages.length > 0) {
            console.log('📥 Loading saved tour messages:', savedMessages.length);
            setTourMessages(savedMessages);
        }
    }, []);
    
    // Reload tour messages on route change to ensure fresh data
    useEffect(() => {
        const savedMessages = loadTourMessages();
        console.log('🔄 Route changed, reloading tour messages:', savedMessages.length);
        setTourMessages(savedMessages);
    }, [location.pathname]);
    
    // Note: We no longer auto-save on every tourMessages change
    // Instead, we explicitly save only the relevant messages in handleTourSectionSelect
    // to avoid carrying over generic welcome messages from the homepage

    // Temporary fallback: if userArticle is not loaded but we have user data in localStorage
    const effectiveUserData = userArticle || user;
    
    // Tour handlers
    const getNextSection = (currentSection) => {
        const sections = Object.keys(TOUR_SECTIONS);
        const currentIndex = sections.indexOf(currentSection);
        return sections[currentIndex + 1] || null;
    };

    const handleTourOptionSelect = (option) => {
        if (option === 'continue') {
            handleTourContinue();
            return;
        }
        
        if (option === 'menu') {
            handleTourMenu();
            return;
        }
        
        if (option === 'done') {
            handleTourDone();
            return;
        }

        if (option === 'Explore More') {
            handleTourExploreMore();
            return;
        }
        
        handleTourSectionSelect(option);
    };
    
    const handleTourSectionSelect = (sectionName) => {
        setCurrentTourSectionState(sectionName);
        setCurrentTourSection(sectionName);
        
        const tourSection = TOUR_CONTENT[sectionName];
        if (!tourSection) return;
        
        const sectionInfo = TOUR_SECTIONS[sectionName];
        const startTime = Date.now();
        const navigationId = `nav-${Date.now()}`; // Unique ID for this navigation message
        
        // Add user's choice message first
        setTourMessages(prev => [...prev, {
            role: 'user',
            text: `${sectionInfo.icon} ${sectionInfo.name}`,
            isTourMessage: true
        }]);
        
        // Show the interactive "taking you there" message
        setTimeout(() => {
            const takingYouThereMessage = {
                role: 'assistant',
                text: tourSection.intro.navigationText || tourSection.intro.text.split('\n\n')[0],
                isTourMessage: true,
                isNavigationMessage: true, // Mark as navigation to style differently
                navigationId: navigationId // Add ID to find and update later
            };
            
            // Append navigation message to existing chat (keep conversation flow)
            setTourMessages(prev => [...prev, takingYouThereMessage]);
            
            // Save the complete conversation including the navigation message
            setTourMessages(current => {
                saveTourMessages(current);
                return current;
            });
            
            // Then navigate after showing the message
            if (tourSection.intro.navigate) {
                setIsNavigatingTour(true);
                setTimeout(() => {
                    navigation(tourSection.intro.navigate);
                    setIsNavigatingTour(false);
                    
                    // Update the navigation message to show completion
                    const elapsedTime = Math.round((Date.now() - startTime) / 1000);
                    setTourMessages(prev => prev.map(msg => 
                        msg.navigationId === navigationId 
                            ? {
                                ...msg,
                                text: msg.text.replace('Navigating to', 'Navigated to') + ` (${elapsedTime}s)`
                            }
                            : msg
                    ));
                    
                    // Always add the welcome message after navigation completes
                    setTimeout(() => {
                        const welcomeMessage = getSectionWelcomeMessage(sectionName);
                        if (welcomeMessage) {
                            setTourMessages(prev => [...prev, welcomeMessage]);
                        }
                        
                        // Save the updated messages
                        setTourMessages(current => {
                            saveTourMessages(current);
                            return current;
                        });
                    }, 500); // Small delay after navigation completes
                }, tourSection.intro.delay || 1500);
            }
        }, 100);
    };
    
    const handleTourContinue = () => {
        setTourMessages(prev => [...prev, {
            role: 'user',
            text: 'Continue to next section',
            isTourMessage: true
        }]);
        
        setTimeout(() => {
            const nextSection = getNextSection(currentTourSectionState);
            
            if (nextSection) {
                setTourMessages(prev => [...prev, {
                    role: 'assistant',
                    text: QUICK_RESPONSES.continue,
                    isTourMessage: true
                }]);
                
                setTimeout(() => {
                    handleTourSectionSelect(nextSection);
                }, 800);
            } else {
                setTourMessages(prev => [...prev, {
                    role: 'assistant',
                    text: QUICK_RESPONSES.done,
                    showOptions: true,
                    options: ['done'],
                    isTourMessage: true
                }]);
                completeTour();
            }
        }, 300);
    };
    
    const handleTourMenu = () => {
        setTourMessages(prev => [...prev, {
            role: 'user',
            text: 'Reload menu',
            isTourMessage: true
        }]);
        
        setTimeout(() => {
            const currentSection = getCurrentTourSection();
            
            if (currentSection) {
                // If we're in a section, show the section welcome message again
                const sectionWelcome = getSectionWelcomeMessage(currentSection);
                if (sectionWelcome) {
                    setTourMessages(prev => [...prev, sectionWelcome]);
                }
            } else {
                // If we're not in a section, show the main menu
                setTourMessages(prev => [...prev, {
                    role: 'assistant',
                    text: QUICK_RESPONSES.menu,
                    isTourMessage: true
                }]);
                
                setTimeout(() => {
                    setTourMessages(prev => [...prev, {
                        role: 'assistant',
                        text: "Ready to dive in? I can teach you about:",
                        showOptions: true,
                        options: Object.keys(TOUR_SECTIONS),
                        showQuestions: true,
                        isTourMessage: true
                    }]);
                }, 500);
            }
        }, 300);
    };
    
    const handleTourDone = () => {
        setTourMessages(prev => [...prev, {
            role: 'user',
            text: "I'm ready to start!",
            isTourMessage: true
        }]);
        
        setTimeout(() => {
            setTourMessages(prev => [...prev, {
                role: 'assistant',
                text: "Awesome! You're all set. Feel free to explore on your own or ask me anything. I'm here whenever you need help!",
                isTourMessage: true
            }]);
            completeTour();
        }, 300);
    };

    const handleTourExploreMore = () => {
        setTourMessages(prev => [...prev, {
            role: 'user',
            text: 'Explore More Apps',
            isTourMessage: true
        }]);
        
        setTimeout(() => {
            const exploreMessage = {
                role: 'assistant',
                text: `Great! Here are all the DIZEE apps you can explore:`,
                showOptions: true,
                options: Object.keys(TOUR_SECTIONS),
                isTourMessage: true
            };
            setTourMessages(prev => [...prev, exploreMessage]);
        }, 300);
    };
    
    const handleTourQuestionSelect = (question) => {
        setTourMessages(prev => [...prev, {
            role: 'user',
            text: question,
            isTourMessage: true
        }]);
        
        // Check if we're in a section and if the question is section-specific
        const currentSection = getCurrentTourSection();
        let answer = null;
        
        // First, try to find the answer in section-specific Q&A
        if (currentSection && SECTION_QA[currentSection] && SECTION_QA[currentSection].answers[question]) {
            answer = {
                text: SECTION_QA[currentSection].answers[question],
                showOptions: true,
                options: ['menu'] // Show menu option after section-specific answers
            };
        } else {
            // Fall back to general tour questions
            answer = QUESTION_ANSWERS[question];
        }
        
        if (answer) {
            setTimeout(() => {
                setTourMessages(prev => [...prev, {
                    role: 'assistant',
                    text: answer.text,
                    showOptions: answer.showOptions || true,
                    options: answer.options || ['menu'],
                    isTourMessage: true
                }]);
            }, 400);
        }
    };

    console.log('🔍 Routing Debug:');
    console.log('- userArticle from Redux:', userArticle);
    console.log('- user from localStorage:', user);
    console.log('- effectiveUserData:', effectiveUserData);
    console.log('- token exists:', !!token);
    console.log('- selectedArtist (state):', selectedArtist);

    // If token exists but no user data at all, show loading
    if (token && !effectiveUserData) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: 'black',
                color: 'white',
                fontSize: '16px'
            }}>
                Loading user data...
                <br />
                <small style={{ marginTop: '10px', opacity: 0.7 }}>
                    If this persists, check console for errors
                </small>
            </div>
        );
    }

    // console.log('userArticle', userArticle?.professionRole)
    return (
        <>
            <FloatingTourChat 
                messages={tourMessages}
                setMessages={setTourMessages}
                onTourOptionSelect={handleTourOptionSelect}
                onTourQuestionSelect={handleTourQuestionSelect}
            />
            <Routes >
            {effectiveUserData?.professionRole === "personal" && token &&
                <>
                    <Route path="/" element={<PersonalLanding />} />
                    <Route path="/suggested" element={<Suggested />} />
                    <Route path="/explore" element={<Explore />} />
                    <Route path="/top" element={<Top />} />
                    <Route path="/trending" element={<Trending />} />
                    <Route path="/following" element={<FollowingPersonal />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/:domain" element={<Domain />} />
                    <Route path="/:domain/:focuspage" element={<Domain />} />
                    <Route path="/staging/:domain" element={<Domain />} />
                    <Route path="/staging/:domain/:focuspage" element={<Domain />} />
                    <Route path="/follower/:domain" element={<Follower />} />
                    <Route path="/following/:domain" element={<Following />} />

                </>
            }
            {/* Team Member Routing - Only show team dashboard when not in delegated mode */}
            {['manager', 'agent', 'label', 'publisher', 'business-manager'].includes(effectiveUserData?.professionRole) && 
             !selectedArtist && token &&
                <>
                    <Route path="/" element={<TeamMemberDashboard />} />
                    <Route path="/team-member-dashboard" element={<TeamMemberDashboard />} />
                    <Route path="/manager-dashboard" element={<TeamMemberDashboard />} />
                    <Route path="/team-member/settings" element={<TeamMemberSettings />} />
                    <Route path="/team-member/profile" element={<TeamMemberProfile />} />
                    <Route path="/team-member/subscription" element={<TeamMemberSubscription />} />
                    <Route path="/team-member/advanced" element={<TeamMemberAdvanced />} />
                    <Route path="/team-member/verify-old-email" element={<TeamMemberVerifyOldEmail />} />
                    <Route path="/team-member/new-email" element={<TeamMemberNewEmail />} />
                    <Route path="/team-member/verify-new-email" element={<TeamMemberVerifyNewEmail />} />
                    {/* Redirect any other path back to team dashboard for team members */}
                    <Route path="*" element={<TeamMemberDashboard />} />
                </>
            }
            {/* Artist/Delegated Access Routing - For artists OR team members acting as artists */}
            {(effectiveUserData?.professionRole === "artist" || 
              (['manager', 'agent', 'label', 'publisher', 'business-manager'].includes(effectiveUserData?.professionRole) && selectedArtist)) && token &&

                <>
                    <Route path="/" element={<Landing />} />
                    <Route path="/homepage" element={<Homepage />} />
                    <Route path="/main" element={<PagesApp />} />
                    <Route path="/main/app" element={<Main />} />

                    <Route path="/vault">
                        <Route index element={<UnreleasedApp />} />
                        <Route path=":username" element={<Vault />} />
                        <Route path="add" element={<AddVault />} />
                        <Route path="stream" element={<StreamOverlay />} />
                    </Route>



                    <Route path="/social-edit" element={<SocialEdit />} />
                    <Route path="/:domain" element={<Domain />} />
                    <Route path="/:domain/:focuspage" element={<Domain />} />
                    <Route path="/staging/:domain" element={<Domain />} />
                    <Route path="/staging/:domain/:focuspage" element={<Domain />} />
                    <Route path="/follower/:domain" element={<Follower />} />
                    <Route path="/following/:domain" element={<Following />} />


                    <Route path="/music-data/:domain/:id" element={<MusicDataPage />} />
                    <Route path="/playlist-data/:domain" element={<PlaylistDataPage />} />

                    <Route path="/add-section">
                        <Route index element={<AddSection />} />
                        <Route path="video-message" element={<VideoMessage />} />
                        <Route path="video-message/publish" element={<PublishOption />} />

                        <Route path="add-music" element={<AddMusic />} />
                        <Route path="search-for-release" element={<SearchForRelease />} />
                        <Route path="music-platform" element={<MusicPlatformPage />} />
                        <Route path="music-manual-entry" element={<ManualEntry />} />
                        <Route path="manual-music-link" element={<AddLink />} />
                        <Route path="custom-music-link" element={<CustomPage />} />
                        <Route path="music-playback" element={<PlayBackOption />} />
                        {/* Publish */}
                        <Route path="music/publish" element={<PublishOption />} />
                        <Route path="music/manual/publish" element={<PublishOption />} />

                        <Route path="add-video" element={<SelectVideoPlatform />} />
                        <Route path="add-video-link" element={
                            <AddLinkVideo
                                state={{
                                    iconKey: 'youtube',
                                    name: 'YouTube'
                                }}
                            />
                        } />
                        <Route path="video/publish" element={<PublishOption />} />
                        {/* <Route path="import-video" element={<ImportVideo />} /> */}
                        {/* <Route path="custom-video-link" element={<CustomVideo />} /> */}

                        <Route path="add-event" element={<AddEvent />} />
                        <Route path="bulk-import-events" element={<BlukImportEvent />} />
                        <Route path="import-single-event" element={<ImportSingleEvent />} />
                        <Route path="single-import-link" element={<ImportLink />} />
                        <Route path="custom-event-link" element={<CustomEvent />} />
                        <Route path="date-picker" element={<DatePickerPage />} />
                        <Route path="event/publish" element={<PublishOption />} />
                        {/* <Route path="add-video" element={<AddEvent />} /> */}

                        <Route path="add-product" element={<AddProduct />} />
                        {/* <Route path="import-product" element={<ImportProduct />} /> */}
                        <Route path="import-product" element={<ImportBulkProduct />} />
                        <Route path="connect-with-shopify" element={<ConnectWithShopify />} />
                        <Route path="product-import-link" element={<ImportLinkProduct />} />
                        <Route path="manually-add-product" element={<ManuallyAddProduct />} />
                        <Route path="product/manual/publish" element={<PublishOption />} />

                        <Route path="add-playlist" element={<PlaylistPlatform />} />
                        <Route path="add-playlist-link" element={<PlaylistLink />} />
                        <Route path="playlist/publish" element={<PublishOption />} />

                        <Route path="add-form" element={<AddForm />} />
                        <Route path="add-form-link" element={<AddFormLink />} />
                        <Route path="add-form-link/publish" element={<PublishOption />} />
                        <Route path="add-poll" element={<AddPoll />} />

                        <Route path="add-social-feed" element={<AddSocialFed />} />
                        <Route path="add-social-feed-link" element={<AddLinkSocialFeed />} />
                        <Route path="add-social-feed/publish" element={<PublishOption />} />

                        <Route path="custom">
                            <Route index element={<CustomSection />} />
                            <Route path="create-new" element={<CreateNew />} />
                            <Route path="select-style" element={<SelectStyle />} />
                            <Route path="existing" element={<ExistingSection />} />
                            <Route path="publish" element={<PublishOption />} />

                            {/* <Route path="add-content" element={<AddContent />} /> */}


                            <Route path="music/add-content" element={<AddMusicContent1 />} />
                            <Route path="video/add-content" element={<AddVideoContent1 />} />
                            <Route path="event/add-content" element={<AddEventContent1 />} />
                            <Route path="product/add-content" element={<AddProductContent1 />} />
                            <Route path="social/add-content" element={<AddSocialContent1 />} />
                            <Route path="text/add-content" element={<AddTextContent1 />} />
                            <Route path="form/add-content" element={<AddFormContent1 />} />
                            <Route path="gallery/add-content" element={<AddGalleryContent1 />} />

                            <Route path="music/edit-content" element={<EditMusicContent1 />} />
                            <Route path="video/edit-content" element={<EditVideoContent1 />} />
                            <Route path="event/edit-content" element={<EditEventContent1 />} />
                            <Route path="product/edit-content" element={<EditProductContent1 />} />
                            <Route path="social/edit-content" element={<EditSocialContent1 />} />
                            <Route path="text/edit-content" element={<EditTextContent1 />} />
                            <Route path="form/edit-content" element={<EditFormContent1 />} />
                            <Route path="gallery/edit-content" element={<EditGalleryContent1 />} />

                        </Route>

                        {/* <Route path="add-custom-link" element={<AddCustomlink />} /> */}
                        {/* <Route path="select-section" element={<ExistingSection />} /> */}
                        {/* <Route path="create-section" element={<CreateNewSection />} /> */}
                        {/* <Route path="add-custom-link/publish" element={<PublishOption />} /> */}

                    </Route>
                    <Route path="/focus-page">
                        <Route index element={<Selectpage />} />
                        <Route path="focus-type" element={<SelectType />} />

                        {/* music  */}
                        <Route path="music-page" element={<MusicPage />} />
                        <Route path="multiple-music-page" element={<MultipleMusicPage />} />
                        <Route path="music-type">
                            <Route index element={<SelectMusicType />} />
                            <Route path="step1" element={<Step1 />} />
                            <Route path="step2" element={<Step2 />} />
                            <Route path="step3" element={<Step3 />} />
                            <Route path="step4" element={<Step4 />} />
                            <Route path="step5" element={<Step5 />} />
                            <Route path="step6" element={<Step6 />} />
                            <Route path="step7" element={<Step7 />} />
                            <Route path="step8" element={<Step8 />} />
                            <Route path="step9" element={<Step9 />} />
                            <Route path="multi-step6" element={<MultiStep6 />} />
                            <Route path="edit-single" element={<EditSingleMusic />} />
                            <Route path="edit-single-platforms" element={<EditSingleMusicPlatforms />} />
                            <Route path="edit-multiple" element={<EditMultipleMusic />} />
                            <Route path="edit-multiple-platforms" element={<EditMultipleMusicPlatforms />} />
                        </Route>


                        {/* product  */}
                        <Route path="product-page" element={<ProductPage />} />
                        <Route path="multiple-product-page" element={<MultipleProductPage />} />
                        <Route path="product-type">
                            <Route index element={<SelectProductType />} />
                            <Route path="step1" element={<ProductStep1 />} />
                            <Route path="step2" element={<ProductStep2 />} />
                            <Route path="step3" element={<ProductStep3 />} />
                            <Route path="step4" element={<ProductStep4 />} />
                            <Route path="step5" element={<ProductStep5 />} />
                            <Route path="step6" element={<ProductStep6 />} />
                            <Route path="step7" element={<ProductStep7 />} />
                            <Route path="edit-content" element={<ProductEditContent />} />
                            <Route path="edit-multi-content" element={<EditMultiProductContent />} />
                        </Route>
                        {/* event  */}
                        <Route path="event-page" element={<EventPage />} />
                        <Route path="multiple-event-page" element={<MultipleEventPage />} />
                        <Route path="event-type">
                            <Route index element={<SelectEventType />} />
                            <Route path="step1" element={<EventStep1 />} />
                            <Route path="step2" element={<EventStep2 />} />
                            <Route path="step3" element={<EventStep3 />} />
                            <Route path="step4" element={<EventStep4 />} />
                            <Route path="step5" element={<EventStep5 />} />
                            <Route path="step6" element={<EventStep6 />} />
                            <Route path="step7" element={<EventStep7 />} />
                            <Route path="edit-content" element={<EventEditContent />} />
                            <Route path="edit-multi-content" element={<EditMultiEventContent />} />
                            <Route path="date-picker" element={<DatePickerFocus />} />
                        </Route>
                        {/* event  */}
                        <Route path="newsletter-page" element={<NewsletterPage />} />
                        <Route path="multiple-newsletter-page" element={<MultipleNewsletterPage />} />
                        <Route path="newsletter-type">
                            <Route index element={<SelectNewsletterType />} />
                            <Route path="step1" element={<NewsletterStep1 />} />
                            <Route path="step2" element={<NewsletterStep2 />} />
                            <Route path="step3" element={<NewsletterStep3 />} />
                            <Route path="step4" element={<NewsletterStep4 />} />
                            <Route path="step5" element={<NewsletterStep5 />} />
                            <Route path="step6" element={<NewsletterStep6 />} />
                            <Route path="step7" element={<NewsletterStep7 />} />
                            <Route path="edit-content" element={<NewsletterEditContent />} />
                            <Route path="edit-multi-content" element={<MultiNewsletterEditContent />} />
                            <Route path="date-picker" element={<DatePickerFocus />} />
                        </Route>

                        {/* custom */}
                        <Route path="custom-page" element={<CustomFocusPage />} />
                        <Route path="custom-type">
                            <Route path="step1" element={<CustomStep1 />} />
                            <Route path="step2" element={<CustomStep2 />} />
                            <Route path="step3" element={<CustomStep3 />} />
                            <Route path="step4" element={<CustomStep4 />} />
                            <Route path="step5" element={<CustomStep5 />} />
                            <Route path="step6" element={<CustomStep6 />} />

                            {/* Add routes for each content type */}
                            <Route path="music/add-content" element={<AddMusicContent />} />
                            <Route path="video/add-content" element={<AddVideoContent />} />
                            <Route path="event/add-content" element={<AddEventContent />} />
                            <Route path="product/add-content" element={<AddProductContent />} />
                            <Route path="social/add-content" element={<AddSocialContent />} />
                            <Route path="text/add-content" element={<AddTextContent />} />
                            <Route path="form/add-content" element={<AddFormContent />} />
                            <Route path="gallery/add-content" element={<AddGalleryContent />} />
                            <Route path="text/edit-content" element={<EditTextContent />} />
                            <Route path="form/edit-content" element={<EditFormContent />} />
                            <Route path="gallery/edit-content" element={<EditGalleryContent />} />
                            <Route path="social/edit-content" element={<EditSocialContent />} />
                            <Route path="product/edit-content" element={<EditProductContent />} />
                            <Route path="event/edit-content" element={<EditEventContent />} />
                            <Route path="video/edit-content" element={<EditVideoContent />} />
                            <Route path="music/edit-content" element={<EditMusicContent />} />
                        </Route>
                    </Route>

                    <Route path='more'>
                        <Route index element={<SelectOption />} />

                        <Route path="setting">
                            <Route index element={<SettingOption />} />
                            <Route path="profile" element={<Profile />} />
                            <Route path="profile-edit" element={<ProfilePhoneEdit />} />
                            <Route path="old-phone" element={<OldPhone />} />
                            <Route path="verify-old-phone" element={<VerifyOldPhone />} />
                            <Route path="new-phone" element={<NewPhone />} />
                            <Route path="verify-new-phone" element={<VerifyNewPhone />} />

                            <Route path="verify-old-email" element={<VerifyOldEmail />} />
                            <Route path="new-email" element={<NewEmail />} />
                            <Route path="verify-new-email" element={<VerifyNewEmail />} />

                            <Route path="subscription" element={<Subscription />} />

                            <Route path="advanced" element={<Advanced />} />
                <Route path="advanced/notifications" element={<Notifications />} />
                            <Route path="advanced/delegate-access" element={<DelegateAccess />} />
                            {/* Hidden - Now using /team-management instead */}
                            {/* <Route path="advanced/team-management" element={<TeamManagement />} /> */}
                            {/* <Route path="advanced/team-management/edit/:teamMemberId" element={<TeamMemberEdit />} /> */}
                            <Route path="advanced/close-account" element={<CloseAccount />} />
                            <Route path="advanced/redirect" element={<Redirect />} />

                            <Route path="gmail">
                                <Route index element={<Gmail />} />
                                <Route path="tracking" element={<EmailTracking />} />
                                <Route path="search" element={<EmailSearch />} />
                            </Route>

                            <Route path="payement-success" element={<PaymentSuccess />} />
                            <Route path="payement-failed" element={<PaymentFailed />} />

                        </Route>

                        <Route path="analytics">
                            <Route index element={<Analytics />} />
                            <Route path="app" element={<Analytics />} />
                            <Route path="video-message" element={<VideoMessageAnalytics />} />
                            <Route path="music" element={<MusicAnalytics />} />
                            <Route path="music/:title" element={<MusicPlatformData />} />

                            <Route path="video" element={<VideoAnalytics />} />
                            <Route path="event" element={<EventAnalytics />} />
                            <Route path="product" element={<ProductAnalytics />} />
                            <Route path="playlist" element={<PlaylistAnalytics />} />
                            <Route path="socialfeed" element={<SocialFeedAnalytics />} />
                            <Route path="form" element={<FormAnalytics />} />
                            <Route path="forms" element={<FormsAnalytics />} />
                            <Route path="polls" element={<PollsAnalytics />} />

                            <Route path="filter" element={<Filter />} />
                        </Route>
                    </Route>

                    {/* Apps Routes */}
                    <Route path="/apps">
                        <Route index element={<Appshub />} />
                        <Route path="all" element={<AllApps />} />
                        <Route path="create" element={<Createapp />} />
                        <Route path="chatbot/:id" element={<Createapp />} />
                        <Route path="ai/:id" element={<Createapp />} />
                        <Route path="/apps/imagehost" element={<ImageHostApp />} />
                    </Route>
                    <Route path="/manager" element={<ManagerApp />} />
                    <Route path="/manager-dashboard" element={<TeamMemberDashboard />} />
                    <Route path="/team-member-dashboard" element={<TeamMemberDashboard />} />
                    <Route path="/team-member/settings" element={<TeamMemberSettings />} />
                    <Route path="/bookings">
                        <Route index element={<BookingsViewAll />} />
                        {/* Splash screen kept for future use: <BookingsApp /> */}
                        <Route path="splash" element={<BookingsApp />} />
                        <Route path="login-agency" element={<LoginAgency />} />
                        <Route path="bulk-import" element={
                            <EditProtectedRoute appName="bookings" fallbackPath="/bookings">
                                <BulkImport />
                            </EditProtectedRoute>
                        } />
                        <Route path="manual-add" element={
                            <EditProtectedRoute appName="bookings" fallbackPath="/bookings">
                                <ManualAdd />
                            </EditProtectedRoute>
                        } />
                        <Route path="view-all" element={<BookingsViewAll />} />
                        <Route path="edit/:bookingId" element={
                            <EditProtectedRoute appName="bookings" fallbackPath="/bookings/view-all">
                                <EditBooking />
                            </EditProtectedRoute>
                        } />
                    </Route>
                    <Route path="/catalog">
                        <Route index element={<CatalogViewAll />} />
                        {/* Splash screen kept for future use: <CatalogApp /> */}
                        <Route path="splash" element={<CatalogApp />} />
                        <Route path="browse" element={<BrowseCatalog />} />
                        <Route path="create-listing" element={<CreateListing />} />
                        <Route path="my-listings" element={<MyListings />} />
                        <Route path="login-catalog" element={<LoginCatalog />} />
                        <Route path="import" element={
                            <EditProtectedRoute appName="catalog" fallbackPath="/catalog">
                                <IndividualImport />
                            </EditProtectedRoute>
                        } />
                        <Route path="manual-add" element={
                            <EditProtectedRoute appName="catalog" fallbackPath="/catalog">
                                <ManualAddCatalog />
                            </EditProtectedRoute>
                        } />
                        <Route path="bulk-import" element={
                            <EditProtectedRoute appName="catalog" fallbackPath="/catalog">
                                <BulkImportCatalog />
                            </EditProtectedRoute>
                        } />
                        <Route path="view-all" element={<CatalogViewAll />} />
                        <Route path="edit/:catalogId" element={
                            <EditProtectedRoute appName="catalog" fallbackPath="/catalog/view-all">
                                <EditCatalog />
                            </EditProtectedRoute>
                        } />
                    </Route>
                    <Route path="/merch">
                        <Route index element={<MerchViewAll />} />
                        {/* Splash screen kept for future use: <MerchApp /> */}
                        <Route path="splash" element={<MerchApp />} />
                        <Route path="bulk-import" element={
                            <EditProtectedRoute appName="merch" fallbackPath="/merch">
                                <MerchBulkImport />
                            </EditProtectedRoute>
                        } />
                        <Route path="manual-add" element={
                            <EditProtectedRoute appName="merch" fallbackPath="/merch">
                                <MerchManualAdd />
                            </EditProtectedRoute>
                        } />
                        <Route path="view-all" element={<MerchViewAll />} />
                        <Route path="edit/:merchId" element={
                            <EditProtectedRoute appName="merch" fallbackPath="/merch/view-all">
                                <EditMerch />
                            </EditProtectedRoute>
                        } />
                    </Route>

                    <Route path="/marketplace/*" element={<MarketplaceHub />} />

                    <Route path="/design-overview" element={<DesignOverview />} />
                    
                    {/* Prompts Routes */}
                    <Route path="/prompts">
                        <Route index element={<PromptsHub />} />
                        <Route path="create" element={<CreatePrompt />} />
                        <Route path="edit/:id" element={<CreatePrompt />} />
                    </Route>
                    
                    {/* Prompt Library Route */}
                    <Route path="/prompt-library" element={<PromptLibrary />} />
                    
                    {/* Analytics Routes */}
                    <Route path="/analytics">
                        <Route index element={<AnalyticsHub />} />
                        <Route path="hub" element={<AnalyticsHub />} />
                        <Route path="experts" element={<ExpertsAnalytics />} />
                        <Route path="tour-manager" element={<TourManagerAnalytics />} />
                        <Route path="bookings" element={<BookingsAnalytics />} />
                        <Route path="catalog" element={<CatalogAnalytics />} />
                        <Route path="merch" element={<MerchAnalytics />} />
                        <Route path="charting" element={<ChartingAnalytics />} />
                        <Route path="playlisting" element={<PlaylistingAnalytics />} />
                        <Route path="social-listening" element={<SocialListeningAnalytics />} />
                        <Route path="spotify-revenue" element={<SpotifyRevenueAnalytics />} />
                    </Route>
                    
                    {/* Usage Dashboard Route */}
                    <Route path="/usage/dashboard" element={<UsageDashboard />} />

                    {/* Activity Feed Route */}
                    <Route path="/activity-feed" element={<ActivityFeedPage />} />

                    {/* New Apps Routes */}
                    <Route path="/apps/new-app" element={<Createapp />} />
                    <Route path="/apps/new-app/:id" element={<Createapp />} />
                    <Route path="/apps/chatbot/:id" element={<Createapp />} />
                    <Route path="/apps/ai/:id" element={<Createapp />} />
                    <Route path="/apps/imagehost" element={<ImageHostApp />} />
                    <Route path="/charting" element={<ChartingApp />} />
                    <Route path="/playlisting" element={<PlaylistingApp />} />
                    <Route path="/social-listening" element={<SocialListeningApp />} />
                    <Route path="/spotify-revenue" element={<SpotifyRevenueApp />} />
                    <Route path="/reminders">
                        <Route index element={<RemindersApp />} />
                        <Route path="quick-add" element={<QuickReminder />} />
                        <Route path="manual-add" element={<ManualAddReminder />} />
                    </Route>
                    <Route path="/flows">
                        <Route index element={<FlowsApp />} />
                        <Route path="create" element={<FlowsCreate />} />
                        <Route path="quick-add" element={<FlowsQuickReminder />} />
                        <Route path="create-workflow" element={<CreateCustomWorkflow />} />
                        <Route path="song-release" element={<CreateCustomWorkflow />} />
                        <Route path="upcoming-show" element={<CreateCustomWorkflow />} />
                        <Route path="view-all" element={<FlowsViewAll />} />
                        <Route path="workflow/:workflowId" element={<WorkflowDetail />} />
                    </Route>
                    <Route path="/knowledge-base">
                        <Route index element={<KnowledgeBaseApp />} />
                        <Route path="article/:articleId" element={<KnowledgeBaseArticle />} />
                    </Route>
                    <Route path="/contacts">
                        <Route index element={<ContactsApp />} />
                        <Route path="add" element={<AddContact />} />
                    </Route>
                    <Route path="/notes">
                        <Route index element={<NotesApp />} />
                        <Route path=":noteId" element={<NoteDetail />} />
                    </Route>
                    <Route path="/tour-manager">
                        <Route index element={<TourManagerApp />} />
                        <Route path="view-all" element={<ViewAllTourManager />} />
                        <Route path="bulk-import" element={<BulkImportTourManager />} />
                        <Route path="show/:showId" element={<TourShowDetail />} />
                        <Route path="flight-search" element={<FlightSearch />} />
                        <Route path="hotel-search" element={<HotelSearch />} />
                        <Route path="tour-router" element={<TourRouter />} />
                        <Route path="tour-overview/:planId" element={<TourOverview />} />
                        <Route path="add-ground-transport/:showId" element={<AddGroundTransport />} />
                    </Route>
                    <Route path="/connectors">
                        <Route index element={<ConnectorsApp />} />
                        <Route path="google" element={<GoogleConnector />} />
                        <Route path="google-calendar" element={<GoogleCalendarConnector />} />
                        <Route path="bandsintown" element={<BandsintownConnector />} />
                    </Route>
                    <Route path="/tasks">
                        <Route index element={<TasksApp />} />
                        <Route path="quick-add" element={<TasksQuickReminder />} />
                    </Route>
                    <Route path="/team-management">
                        <Route index element={<TeamManagementApp />} />
                        <Route path="edit/:teamMemberId" element={<TeamMemberEdit />} />
                    </Route>
                    <Route path="/email">
                        <Route index element={<EmailApp />} />
                        <Route path="tracking" element={<EmailAppTracking />} />
                        <Route path="search" element={<EmailAppSearch />} />
                    </Route>
                    <Route path="/spotify-callback" element={<SpotifyCallback />} />
                    <Route path="/gmail-callback" element={<GmailCallback />} />
                    <Route path="/google-calendar-callback" element={<GoogleCalendarCallback />} />
                    <Route path="/google-callback" element={<GoogleCallback />} />
                </>
            }
            {/* Fallback routing - when effectiveUserData is loading or unknown role */}
            {(!effectiveUserData?.professionRole || 
              !['personal', 'artist', 'manager', 'agent', 'label', 'publisher', 'business-manager'].includes(effectiveUserData?.professionRole)) && token &&
                <>
                    <Route path="/" element={<Landing />} />
                    <Route path="/team-member-dashboard" element={<TeamMemberDashboard />} />
                    <Route path="/manager-dashboard" element={<TeamMemberDashboard />} />
                    <Route path="*" element={<Landing />} />
                </>
            }

        </Routes>
        </>
    )
}

export default PrivateRoutes
